/*
 *全景界面
 */

import Ui from '../../components/ui';

function setUi(params) {
  if (!params || !params.data) return;
  this.Ui = new Ui({
    wrapper: this.$container.get(0),
    ...params
  });
}

function detailsShow(){
  this.Ui.detailsShow();
}

function detailsHide(){
  this.Ui.detailsHide();
}

function setBtnBg(domId,bollean){
  this.Ui.setBtnBg(domId,bollean);
}

function setUiHtml(){
  this.Ui.setBtnHtml();
}

export default {
  setUi,
  detailsShow,
  detailsHide,
  setBtnBg,
  setUiHtml
};